import { LinearProgressMeter } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import React from 'react'
import * as styles from './amountProgress.css'

interface Props {
  targetAmount?: {
    value: string
    currencyCode: string
  }
  isSmallerScreen: boolean
  collectedAmount?: {
    value: string
    currencyCode: string
  }
  formattedCollectedAmount: string
  formattedTargetAmount: string
  formattedCurrentAmount: string
}

export const AmountProgress = ({
  targetAmount,
  isSmallerScreen,
  collectedAmount,
  formattedCollectedAmount,
  formattedTargetAmount,
  formattedCurrentAmount,
}: Props) => {
  return (
    <>
      {targetAmount ? (
        <LinearProgressMeter
          max={targetAmount.value}
          value={collectedAmount.value}
          steps={formattedCollectedAmount}
          title={formattedTargetAmount}
          data-testid="datatestProgressBar"
          size={isSmallerScreen ? 'sm' : undefined}
          className={styles.progressBarPadding}
        />
      ) : (
        <div className={styles.receivedSoFarAmount} data-testid="receivedSoFar">
          <Message
            id="flatProgress.receivedSoFar"
            receivedAmount={formattedCurrentAmount}
          />
        </div>
      )}
    </>
  )
}
